import * as echarts from "echarts";
import { getProfitRate2 } from "../../api/realTimeData"
import { handelBtcPrice, dataLength, emptyData, chartsWidth, handelProfitrate, handelZoom, handelLineType, handelSwitchs, handelWatermark, handelSmaData, getDateArray, fetchBtcPrice, fetchEthPrice } from "../../util/processingData"
export default {
    data() {
        return {
            lengthTimer: null,

            params: {
                req: "profitRate",
                radius: "btc"
            },
            profitRateLoading: false,
            profitRateData: [],
            option: {
                tooltip: {
                    trigger: "axis",

                    //解决tooltip显示不全问题1 
                    confine: true,
                    formatter: (params) => {
                        
                        if (params[0].axisType == `xAxis.time`) {
                            const date = new Date(params[0].value[0]);
                            const year = date.getFullYear();
                            const month = date.getMonth() + 1;
                            const day = date.getDate();
                            let time =  `${year}-${month}-${day}`;
                            var res =time    
                        }else{
                            var res = params[0].axisValue
                        }
                        for (let i = 0; i < params.length; i++) {
                            if (Array.isArray(params[i].value)) {
                                if (params[i].seriesName !== `Price[BTC]`) {
                                    res += `</br>${params[i].marker} ${params[i].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[i].value[1]}%</span>`

                                } else {
                                    res += `</br>${params[i].marker} ${params[i].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[i].value[1]}</span>`

                                }

                            } else {

                                if (params[i].seriesName !== `Price[BTC]`) {
                                    res += `</br>${params[i].marker} ${params[i].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[i].value}%</span>`

                                } else {
                                    res += `</br>${params[i].marker} ${params[i].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[i].value}</span>`

                                }

                            }

                        }
                        // if (params[1] && !params[2]) {
                        //     res += `</br>${params[0].marker} ${params[0].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[0].value[1]}%</span>
                        //     </br>${params[1].marker}   ${params[1].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[1].value[1]}</span>`;

                        // } else if (params[2]) {
                        //     res += `</br>${params[0].marker} ${params[0].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[0].value[1]}%</span>
                        //     </br>${params[1].marker}   ${params[1].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[1].value[1]}</span>
                        //     </br>${params[2].marker}   ${params[2].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[2].value[1]}</span>`;

                        // } else {
                        //     res += `</br>${params[0].marker}  ${params[0].seriesName} &nbsp&nbsp&nbsp&nbsp <span style="font-weight: bold">${params[0].value[1]}%</span>
                        //    `;

                        // }


                        return res;
                    }
                },
                legend: {
                    right: "100"
                },
                xAxis: {
                    type: "time",
                    boundaryGap: false,
                    //   axisLabel: {
                    //     formatter: `{yyyy}-{MM}-{dd}`,
                    //   },
                    data: []
                },
                yAxis: [
                    {
                        type: "value",
                        // show:"false",
                        // boundaryGap: [0, "100%"],
                        // axisLabel: {
                        //   formatter: function (e) {

                        //     let value;
                        //     if (e > 1000000) {
                        //       value = e / 100000;
                        //     } else if (e > 100000) {
                        //       value = e / 1000;
                        //     } else {
                        //       value = e / 100;
                        //     }
                        //     return value;
                        //   },
                        // },
                        min: "dataMin",
                        max: "dataMax",
                    },
                    {
                        type: "value",
                        // boundaryGap: [0, "100%"],
                        show: true,
                        position: "right"
                    },
                    {
                        type: "value",
                        // boundaryGap: [0, "100%"],
                        show: false,
                    },
                ],
                dataZoom: [
                    {
                        type: "inside",
                        start: 0,
                        end: 100,
                    },
                    {
                        start: 0,
                        end: 100,
                    },
                ],
                series: [
                    {
                        name: "Daily Percent UTXOs in Profit",
                        type: "line",
                        smooth: false,
                        symbol: "circle",
                        showSymbol: false,
                        symbolSize: 5,
                        // areaStyle: {},
                        itemStyle: {
                            color: "#f7931a",
                            borderColor: "rgba(221,220,107,0.1)",
                            borderWidth: 12,
                        },
                        lineStyle: {
                            //线条样式
                            color: "#f7931a",
                            width: "1",
                        },
                        data: [],

                    },
                    {
                        name: "Price[BTC]",
                        type: "line",
                        smooth: false,
                        symbol: "circle",
                        symbolSize: 5,
                        showSymbol: false,
                        // areaStyle: {},
                        itemStyle: {
                            color: "#888888",
                            borderColor: "rgba(221,220,107,0.1)",
                            borderWidth: 12,
                        },
                        lineStyle: {
                            //线条样式
                            color: "#888888",
                            width: "1",
                        },
                        yAxisIndex: 1,
                        data: [],
                        //绘制右侧Y轴
                        markLine: {
                            symbol: ["none", "none"], //去掉箭头
                            itemStyle: {
                                normal: {
                                    lineStyle: { type: "solid", color: "rgba(0,0,0,0.01)" },
                                },
                            },
                            // lineStyle:{
                            //   color:"red"
                            // },

                            label: {
                                formatter: "{b}",
                                fontSize: 10,
                                color: "rgba(0,0,0,0.8)",
                                align: "left",
                            },
                            data: [
                                // {
                                //     name: "0",
                                //     yAxis: 0,
                                // },
                                //  {
                                //   name: "$40W",
                                //   yAxis: 400000,
                                // },
                                {
                                    name: "$70W",
                                    yAxis: 700000,
                                },
                                {
                                    name: "$40W",
                                    yAxis: 400000,
                                },

                                {
                                    name: "$10W",
                                    yAxis: 100000,
                                },
                                {
                                    name: "$100W",
                                    yAxis: 1000000,
                                    // position: ['100%', '50'],
                                },
                                {
                                    name: "$120W",
                                    yAxis: 1200000,
                                },

                                {
                                    name: "$140W",
                                    yAxis: 1400000,
                                },
                            ],
                        },
                    },
                    // {
                    //     name: "Price [ETH]",
                    //     type: "line",
                    //     smooth: false, //线条是否圆滑
                    //     symbol: "circle",
                    //     symbolSize: 5,
                    //     showSymbol: false,
                    //     itemStyle: {
                    //       color: "#627eea",
                    //       borderColor: "rgba(221,220,107,0.1)",
                    //       borderWidth: 12,
                    //     },
                    //     lineStyle: {
                    //       //线条样式
                    //       color: "#627eea",
                    //       width: "1",
                    //     },
                    //     yAxisIndex: 2,
                    //     data: [],
                    //   },

                ],
            },
            priceTime: "",
            btcPrice: [],
            parmesTime: {
                start: "",
                end: ""
            },
            switch3: "",
            btcFlag: null,
            ethFlag: null,
            fatherSmaData: [],
            start: "",
            end: "",
            sma: "",
            times: {
                start: "",
                end: ""
            },
            zoomStart: 0,
            zoomEnd: 0,
            dataSelection: [
                {
                    value: "1d",
                    label: "home.day1",
                    disabled: false,
                    authority: "guest",
                    grade: 1,
                },
                {
                    value: "realTime",
                    label: "home.realTimeData",
                    disabled: false,
                    authority: "vip",
                    grade: 4,
                },
            ],
            realTimeData: "",

        }
    },
    mounted() {
        this.fetchProfitrate(this.params.req, this.params.radius)
        this.switch3 = handelSwitchs(this.option, this.switch3)

        this.ethFlag = JSON.parse(localStorage.getItem("ethFlag"));
        this.btcFlag = JSON.parse(localStorage.getItem("btcFlag"));
        this.$addStorageEvent(1, "zoomStart", this.zoomStart);
        this.$addStorageEvent(1, "zoomEnd", this.zoomEnd);
        window.addEventListener("setItem", () => {
            this.ethFlag = JSON.parse(localStorage.getItem("ethFlag"));
            this.btcFlag = JSON.parse(localStorage.getItem("btcFlag"));
            this.zoomStart = localStorage.getItem("zoomStart")
            this.zoomEnd = localStorage.getItem("zoomEnd")

        })


    },
    methods: {
        handleSelect(activeValue) {
            if (activeValue == "1d") {
                this.realTimeData = false
                this.fetchProfitrate(this.params.req, this.params.radius)
            } else {
                this.fetchProfitRate2()
                this.realTimeData = true
            }
        },
        //初始化图表
        inCharts() {
            if (this.myChart == null) {
                this.myChart = echarts.init(document.getElementById("profitRateBox"));
            }
            this.option = handelZoom(this.myChart, this.option, this, this.zoomStart, this.zoomEnd)

            this.myChart.setOption(this.option);
            chartsWidth("profitRateBox", this);
            window.addEventListener("resize", () => {
                if (this.myChart) this.myChart.resize();
            });
        },
        //实时数据
        async fetchProfitRate2() {
            this.profitRateLoading = true
            const { data } = await getProfitRate2()
            let ProfitRate2 = data.data
            //空数据处理
            let noData = emptyData(data.data, this.option.series, this.inCharts, this)
            if (noData) {
                this.profitRateLoading = false
                return
            }

            this.option.xAxis.type = "category"
            this.option = handelWatermark(this.option)
            let profitRate = []
            let xAxisData = []
            let price = []
            ProfitRate2.forEach(item => {
                item.date = `${item.date.split("T")[0]} ${item.date.split("T")[1].split(`.`)[0]
                    } `;
                profitRate.push((item.value * 100).toFixed(2))
                xAxisData.push(item.date)
                price.push(item.price.toFixed(2))
            })

            this.option.xAxis.data = xAxisData
            this.option.series[0].data = profitRate
            this.option.series[1].data = price


            this.inCharts()
            this.profitRateLoading = false
        },
        //请求数据并渲染
        async fetchProfitrate(req, radius, start, end, sma) {
            this.profitRateLoading = true
            const { data } = await this.$API.getProfitrate(req, radius, start, end, sma)
            this.profitRateData = data.data
            //空数据处理
            let noData = emptyData(data.data, this.option.series, this.inCharts, this)
            if (noData) {
                this.profitRateLoading = false
                return
            }
            this.start = this.profitRateData[0].date.split("T")[0]
            this.end = this.profitRateData[this.profitRateData.length - 1].date.split("T")[0]
            this.option.xAxis.type = "time"
            //添加水印
            this.option = handelWatermark(this.option)
            //根据渲染的数据时间渲染对应的价格线和移动平均线
            this.$nextTick(() => {
                //移动平均线没值 才渲染正常价格数据 
                if (this.start && !this.fatherSmaData[0]) {
                    this.handelSonBtcPrice("BTC", true)
                }
                //点击时间 移动平均线有值 就渲染查询移动平均线
                if (this.fatherSmaData[0] && this.start) {
                    this.handelSonSma(this.fatherSmaData, this.start, this.end)
                }
                //渲染ETH
                if (this.ethFlag) {
                    this.$addStorageEvent(1, "ethFlag", JSON.stringify(this.ethFlag));
                    this.handelSonEthPrice("ETH", this.ethFlag)
                }
            })
            let profitRateValueList = []
            this.profitRateData.forEach(item => {

                this.timer = item.date.split("T")[0]
                profitRateValueList.push(Number((item.value * 100).toFixed(2)))
            })
            this.option.series[0].data = handelProfitrate(this.profitRateData, profitRateValueList)

            this.inCharts()
            this.profitRateLoading = false

            //判定页面条数是否一致
            if (this.lengthTimer) {
                clearTimeout(this.lengthTimer)
            }
            this.lengthTimer = setTimeout(() => {

                this.$addStorageEvent(1, "lengthFlag", dataLength(this.option, this.option.series[0].data.length),);

            }, 10000)
        },
        //接收Home传的时间handelParmesTime
        handelSonTime(start, end) {
            this.parmesTime.start = start;
            this.parmesTime.end = end;
            this.fetchProfitrate(this.params.req, this.params.radius, this.parmesTime.start, this.parmesTime.end, this.sma)
        },

        //点击对数/线性按钮切换
        handelLineSwitch() {
            this.option = handelLineType(this.option)
            this.switch3 = handelSwitchs(this.option, this.switch3)
            this.myChart.setOption(this.option);

        },
        // 请求BTC价格
        async fetchBtcPrice(radius, start, end) {
            //请求BTC价格
            const price = await this.$API.getBtcPrice2(radius, start, end);
            this.btcPrice = price.data.data
            if (!this.btcPrice) {//价格未查询到数据的情况              
                this.option.series[1].data.length = 0

            } else {

                let priceValueList = []
                let newPriceData = []
                this.btcPrice.forEach(price => {
                    priceValueList.push(Number(parseInt(price.value * 100) / 100))
                    newPriceData.push(price)
                })
                this.option.series[1].data = handelBtcPrice(newPriceData, priceValueList)

            }
            this.inCharts()
        },
        // 请求Eth价格
        async fetchEthPrice(radius, start, end) {
            const price = await this.$API.getBtcPrice2(radius, start, end);
            this.ethPrice = price.data.data
            if (!this.ethPrice) {
                this.option.series[2].data.length = 0
            } else {
                let priceValueList = []
                let newPriceData = []
                this.ethPrice.forEach(price => {
                    priceValueList.push(Number(parseInt(price.value * 100) / 100))
                    newPriceData.push(price)
                })
                this.option.series[2].data = handelBtcPrice(newPriceData, priceValueList)
            }

            this.inCharts()
        },
        //父级点击BTC价格按钮
        handelSonBtcPrice(radius, flag) {
            this.btcFlag = flag
            fetchBtcPrice("BTC", this.option.series[1], this.start, this.end, this.inCharts, this, this.btcFlag)


        },
        //父级点击ETH价格按钮
        handelSonEthPrice(radius, flag) {

            this.ethFlag = flag
            this.$addStorageEvent(1, "ethFlag", JSON.stringify(this.ethFlag));
            fetchEthPrice("ETH", this.option.series[2], this.start, this.end, this.inCharts, this, this.ethFlag)


        },
        //父级选择Sma
        handelSonSma(smaDataList) {
            this.sma = smaDataList

            this.fetchProfitrate(this.params.req, this.params.radius, this.parmesTime.start, this.parmesTime.end, this.sma)

            this.$addStorageEvent(1, "sma", this.sma);

            this.realTimeData = false

            // this.fatherSmaData = smaDataList      
            // handelSmaData(smaDataList,this.option.series[1],this.inCharts,this.start, this.end)

        },

    },
    beforeDestroy() {
        if (this.lengthTimer) {
            clearTimeout(this.lengthTimer)
        }
    }

}